











































































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import _ from 'lodash';
import MyNav from '@/components/nav/Index.vue'; // nav
import Read from '@/servers/modules/vocabulary/read'; // server
import {
  Button, Message, Scrollbar, Select, Option, Input,
} from 'element-ui';
import MyDialog from '@/components/dialog/Index.vue';
// dialog
import { isOpenAnswer } from '@/plugins/util'
@Component({
  components: {
    MyNav,
    Button,
    Scrollbar,
    Select,
    Option,
    Input,
    MyDialog,
  },
})
export default class extends Vue {
  private isOpenAnswer: boolean = isOpenAnswer()
  // 课程名称
  private courseName: any = '';

  // @ts-ignore
  @Getter public navData: any;

  // @ts-ignore
  @Getter public skeleton: any;

  // @ts-ignore
  @Mutation public setSkeletonDescribe;

  // @ts-ignore
  @Mutation public openDialog;

  // @ts-ignore
  @Mutation public closeDialog;

  // @ts-ignore
  @Getter public scaleCommonIndex: any;

  // 返回参数
  // 列表
  private playing: boolean = false;

  private data: any = '';

  // loading
  private loading: boolean = false;

  private userEnterWord: any = '';

  // 详情
  private listData: any = '';

  private articleValue: any = '';

  // 阅读填空模式
  private isReadStatus: boolean = true;

  // 译文/大意
  private ctex: boolean = false;

  // 当前id 上一篇id 下一篇id
  private currentId: any = '';

  private currentIndex: any = '';

  // 文章主题
  private mainValue: any = '';

  private wordElements: any = [];

  private translateStatus: any = '';

  private pre: boolean = false;

  private next: boolean = false;

  private goBack() {
    this.$router.push({
      path: '/vocabulary/afterschoolexpand',
    });
  }

  private created() {
    this.setSkeletonDescribe(true);
    NProgress.start();
    // this.getArticleDetail();
    this.currentId = this.$route.query.articleUserCourseId;
    this.courseName = window.LS.get('basicData').courseName;
    this.init();
    this.getArticleList();
  }

  private async getArticleList() {
    const res: any = await Read.getArticleList({
      courseId: window.LS.get('vteData').course.courseId,
      userId: window.LS.get('vteData').user.userId,
      userCourseId: window.LS.get('vteData').userCourseId,
    });
    this.listData = res.data.data;
  }

  private async init(CourseId: string = '') {
    const res: any = await Read.getArticleDetail({
      articleUserCourseId: CourseId || this.currentId,
      courseId: window.LS.get('vteData').course.courseId,
      userId: window.LS.get('vteData').user.userId,
      userCourseId: window.LS.get('vteData').userCourseId,
    });
    this.setSkeletonDescribe(true);
    this.data = res.data.data;
    this.articleValue = res.data.data.articleOriginal.title;
    this.mainValue = res.data.data.articleOriginal.content;
    this.wordElements = addLabel(res.data.data.articleOriginalElements);
    this.pre = !!res.data.data.previousId;
    this.next = !!res.data.data.nextId;
    function addLabel(data:any) {
      for (let i = 0; i < data.length; i++) {
        data[i].index = i;
        data[i].class = '';
        if (data[i].needGapFilling) {
          data[i].userElement = "<span style='color:rgba(255, 95, 95, 1)' class='colorTransparent'>?</span>";
        }
      }
      return data;
    }
    // 默认开启填空模式
    this.fillClick();
    NProgress.done();
    this.playing = false;
  }

  // 播放录音
  private playAudio() {    
    // this.loading = true;
    let that = this
    this.playing = true;
    this.$refs.audio.play();
    this.$refs.audio.addEventListener('ended', function () {  
      that.playing = false;
    }, false);
  }

  // get替代每秒轮询current time
  private get isPlaying() {

    return this.$refs.audio.currentTime > 0;
  }

  // 停止录音
  private stopAudio() {
    this.playing = false;
    this.$refs.audio.currentTime = 0;
    this.$refs.audio.pause();
  }

  // 暂停录音
  private pauseAudio() {
    this.playing = false;
    this.$refs.audio.pause();
  }

  // 下拉框选择
  private changeArticleValue(item: any) {

    this.init(item.articleUserCourseId);
  }

  // 译文
  private translate(lang:any) {
    if (lang == 'cn') {
      this.translateStatus = !this.translateStatus;
      this.ctex = !this.ctex;
      // this.mainValue = this.data.articleOriginal.translate;
    }
  }

  // 阅读模式
  private readClick() {
    this.isReadStatus = true;
  }

  // 填空模式
  private fillClick() {
    this.isReadStatus = false;
    // 填空模式时 elementType 为 0 是需要天空的内容
    // this.mainValue = this.data.articleOriginalElements
  }

  // 上一篇
  private prebtn() {
    this.init(this.data.previousId);
    this.articleValue = this.data.previousId;
  }

  // 下一篇
  private nextbtn() {
    this.init(this.data.nextId);
    this.articleValue = this.data.previousId;
  }

  // 比较单词是否相等
  private compareWord(data:any, opera:any) {

    if (data.class == 'span-class') {
      return false;
    }
    if (opera == 'open') {
      this.userEnterWord = '';
      this.openDialog({
        visible: true,
        titleClose: true,
        titleIcon: false,
        data,
        text: '确认输入单词',
        footer: [
          {
            class: 'bcg000000 color333333',
            // - class: 'button-style-border',
            word: '取消',
          },
          {
            // - class: 'bcg225BFE color000000',
            class: 'button-style-background',
            word: '确定',
          },
        ],
      });
    } else if (opera == 'compare') {
      // 如果用户输入 等于 系统的单词
      // vm.$set(vm.arr2, 1, 'alpha');

      const imgSrc = '';
      if (this.userEnterWord.trim() == data.articleOriginalElement.element) {
        this.wordElements[
          data.index
        ] = data.userElement = `<span class="word-span-class" style="color: #4AC80D;background: none;">${this.userEnterWord}</span>`;
        data.userElement += `<img style="width: 48px; height: 48px;" src="${require('../../assets/images/ui-word/word-article-right.png')}" />`;
      } else {
        this.wordElements[
          data.index
        ] = data.userElement = `<span class="word-span-class">${this.userEnterWord}</span>`;
        data.userElement += `<img style="width: 48px; height: 48px;" src="${require('../../assets/images/ui-word/word-article-wrong.png')}" />`;
        data.userElement += `<span class="color4AC80D">（${data.articleOriginalElement.element}）</span>`;
      }
      data.class = 'span-class';

      this.$set(this.wordElements, data.index, data);
      this.closeDialog();
    }
  }

  private dialogHandle(index:number, data:any) {
    if (index == 0) {
      this.closeDialog();
      this.userEnterWord = '';
    } else if (index == 1) {
      this.compareWord(data, 'compare');
    }
  }
}
